/*
Program     :  AvatarMenu.js
Description :  Main program for Logout
Date        :  
Created By  :  jelbin
---------------------------------------------------------------------------------------------
TicketNo         Author         Date              ChangeDesc
---------------------------------------------------------------------------------------------
10062024        - Jelbin     -  10-06-2024       - Added component for logout  
---------------------------------------------------------------------------------------------*/

import * as React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Avatar, ListItemIcon } from '@mui/material';
import AuthService from "../service/AuthService";
import { deepOrange } from '@mui/material/colors';
import { Logout } from '@mui/icons-material';


export default function AvatarMenu(props) {

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLogOut = () => {
        AuthService.logout()
    }
    

    return (
        <div>
            <Button onClick={handleClick}>
                <Avatar sx={{ bgcolor: deepOrange[500] }}>{props.user.username.charAt(0)}</ Avatar>
            </Button>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                <MenuItem onClick={handleLogOut}>
                    <ListItemIcon>
                        <Logout fontSize="small" />
                    </ListItemIcon>
                    Logout
                </MenuItem>
            </Menu>
        </div>
    );
}
